import { render, staticRenderFns } from "./DurationForm.vue?vue&type=template&id=3bc24c1a&scoped=true"
import script from "./DurationForm.vue?vue&type=script&lang=js"
export * from "./DurationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc24c1a",
  null
  
)

export default component.exports